import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import './App.css'; // Import the CSS file
import { API_BASE_URL } from './config'; // Import the API base URL
import ArticleList from './ArticleList'; // Import the new ArticleList component

interface Article {
  id: number;
  title: string;
  description: string;
  url: string;
  published_at: string;
  positivity: number;
  image_url: string;
}

interface HomeProps {
  sliderValue: number; // New prop for slider value
}

const categories = ['Domaci', 'Zahranicni', 'Ekonomika', 'Technika', 'Kultura', 'Sport'];

const categoryMap: { [key: string]: string } = {
  Domaci: 'domácí',
  Zahranicni: 'zahraničí',
  Ekonomika: 'ekonomika',
  Technika: 'technika',
  Kultura: 'kultura',
  Sport: 'sport',
};

const displayCategoryMap: { [key: string]: string } = {
  Domaci: 'Domácí',
  Zahranicni: 'Zahraniční',
  Ekonomika: 'Ekonomika',
  Technika: 'Technika',
  Kultura: 'Kultura',
  Sport: 'Sport',
};

const Home: React.FC<HomeProps> = ({ sliderValue = 7 }) => { // Set default sliderValue to 7
  const { categoryName } = useParams<{ categoryName: string }>(); // Get the selected category
  const [articles, setArticles] = useState<{ [key: string]: Article[] }>(() =>
    categories.reduce((acc, category) => {
      acc[category] = []; // Initialize each category with an empty array
      return acc;
    }, {} as { [key: string]: Article[] })
  );

  useEffect(() => {
    categories.forEach((category) => {
      axios
        .get(API_BASE_URL, { params: { category: categoryMap[category], positivity: sliderValue } }) // Add positivity
        .then((response: { data: Article[] }) => {
          console.log(`Response for category ${category}:`, response.data); // Debug info
          setArticles((prev) => ({
            ...prev,
            [category]: response.data.slice(0, 5),
          }));
          setTimeout(() => {
            document.querySelectorAll('.article').forEach(article => {
              article.classList.add('loaded');
            });
          }, 100); // Delay to ensure articles are rendered before adding the class
        })
        .catch((error: any) => console.error(error));
    });
  }, [sliderValue]); // Add sliderValue as dependency

  console.log('Articles state:', articles); // Debug info

  return (
    <div className="page-container">
      <div className="categories-container">
        {categories.map((category, index) => (
          index % 2 === 0 && (
            <div key={index} className="category-pair">
              <div className={`category ${categoryName === category ? 'selected' : ''}`}>
                <h2>
                  <Link to={`/category/${category}`}>
                    {displayCategoryMap[categories[index]]}
                  </Link>
                </h2>
                <ArticleList articles={articles[categories[index]]} />
              </div>
              {categories[index + 1] && (
                <div className={`category ${categoryName === categories[index + 1] ? 'selected' : ''}`}>
                  <h2>
                    <Link to={`/category/${categories[index + 1]}`}>
                      {displayCategoryMap[categories[index + 1]]}
                    </Link>
                  </h2>
                  <ArticleList articles={articles[categories[index + 1]]} />
                </div>
              )}
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default Home;
